import React, { useEffect, useRef } from 'react';
import '../css/Experience.css';

/* ░░░  DATA  ░░░ */
const jobs = [
  {
    title: 'Full Stack Developer | Sword Garage Web & Mobile App',
    date: 'Oct 2024 – Present · Toronto, Canada',
    bullets: [
      'Designed & launched a multilingual landing page / mobile mechanic platform (React, i18n.js; 6 languages).',
      'Super‑charged SEO with React‑Helmet, dynamic sitemaps & Google Search Console.',
      'Built a Flask + MongoDB backend with JWT auth, scheduling & availability logic.'
    ]
  },
  {
    title: 'Backend Developer | TrioTech Web',
    date: 'Aug 2024 – Oct 2024 · Calgary, Canada',
    bullets: [
      'Shipped a full‑stack messaging system (React ↔ Flask) with JWT and MongoDB.',
      'Architected an Express micro‑backend with RBAC & scalable REST APIs.',
      'Led e‑commerce build: product/order flows, auth, blazing‑fast cart ops.'
    ]
  },
  {
    title: 'Full Stack Developer | Koyuncu Elektronik',
    date: 'Dec 2023 – Aug 2024 · Istanbul, Turkey',
    bullets: [
      'Revamped B2B portals, slicing dealer order time by 30 %.',
      'Integrated logistics APIs, trimming supply‑chain delays 20 %.',
      'Rolled out ISO‑27001‑ready JWT auth for dealer dashboards.'
    ]
  },
  {
    title: 'Junior Backend Developer | Ozkoyuncu Madencilik',
    date: 'Apr 2023 – Dec 2023 · Kayseri, Turkey',
    bullets: [
      'Engineered REST APIs for mine‑sensor feeds (> 2 M t / yr).',
      'Optimised MongoDB queries, dropping report latency 35 %.',
      'Co‑modernised ERP for Turkey’s largest iron‑ore producer.'
    ]
  },
  {
    title: 'Backend Developer – Intern | Ozkoyuncu Madencilik',
    date: 'May 2022 – Aug 2022 · Kayseri, Turkey',
    bullets: [
      'Automated QC reports in Python—50 % less manual labour.',
      'Assisted Express + SQL dashboards for enrichment plants.'
    ]
  }
];

const Experience = () => {
  const sectionRef = useRef(null);

  /* ── 1. Reveal & flip cards on scroll ─────────────────────────── */
  useEffect(() => {
    const cards = sectionRef.current.querySelectorAll('.timeline-item');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add('in');
        });
      },
      { threshold: 0.2 }
    );
    cards.forEach((c) => io.observe(c));
    return () => io.disconnect();
  }, []);

  /* ── 2. Fill centre spine as section scrolls into view ────────── */
  useEffect(() => {
    const sec = sectionRef.current;
    const onScroll = () => {
      const rect = sec.getBoundingClientRect();
      const vp = window.innerHeight;
      const prog = Math.min(
        1,
        Math.max(0, (vp - rect.top) / (rect.height + vp))
      );
      sec.style.setProperty('--spine-fill', prog);
    };
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  /* ── 3. Per‑card tilt toward cursor ───────────────────────────── */
  useEffect(() => {
    const handle = (e) => {
      document.documentElement.style.setProperty(
        '--mouseX',
        e.clientX / window.innerWidth
      );
      document.documentElement.style.setProperty(
        '--mouseY',
        e.clientY / window.innerHeight
      );
    };
    window.addEventListener('pointermove', handle);
    return () => window.removeEventListener('pointermove', handle);
  }, []);

  return (
    <section id="experience" className="experience-section" ref={sectionRef}>
      {/* drifting matrix backdrop */}
      <div className="grid-bg" />

      <h2 className="exp-title">Professional&nbsp;Experience</h2>

      <div className="timeline">
        {jobs.map((job, i) => (
          <div className="timeline-item" key={i}>
            <div className="timeline-card">
              <h3>{job.title}</h3>
              <p className="timeline-date">{job.date}</p>
              <ul>
                {job.bullets.map((b, j) => (
                  <li key={j}>{b}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Experience;
